var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font-weight-bold"},_vm._l((_vm.slugs),function(slug){return _c('span',{key:slug},[_vm._v(_vm._s(slug.toUpperCase())+" > ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }